import { useMissionsTranslation } from '../../../../ui/hooks';
import { convertMillisecondsToHoursWithMinutes } from '../../../../ui/utils/convertMillisecondsToHours';
import UpdateIcon from '@mui/icons-material/Update';
import { Alert } from '@mui/material';
import React from 'react';
export function PendingHoursWarning({ onClose, totalPendingHours }) {
    const { t } = useMissionsTranslation();
    return (React.createElement(Alert, { color: 'warning', icon: React.createElement(UpdateIcon, null), onClose: onClose, sx: { mb: 2 } }, t('timeTracking.pendingHoursApproval', { count: convertMillisecondsToHoursWithMinutes(totalPendingHours) })));
}
